import { Heading_default } from "./chunk-K742HG2N.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Panel/Panel.Header.tsx
import clsx from "clsx";
import { jsx, jsxs } from "react/jsx-runtime";
var PanelHeader = _a => {
  var _b = _a,
    {
      title,
      secondaryAction,
      children,
      className
    } = _b,
    rest = __objRest(_b, ["title", "secondaryAction", "children", "className"]);
  return /* @__PURE__ */jsxs("header", __spreadProps(__spreadValues({}, rest), {
    className: clsx("pd:panel__header", className),
    children: [/* @__PURE__ */jsx(Heading_default, {
      as: "span",
      variant: "display",
      size: "3",
      className: "pd:panel__title",
      children: title
    }), /* @__PURE__ */jsx("div", {
      className: "pd:grow",
      children
    }), /* @__PURE__ */jsx("div", {
      className: "pd:flex",
      children: secondaryAction
    })]
  }));
};
var Panel_Header_default = PanelHeader;
export { Panel_Header_default };